/**
 * Contact Email Section Component
 * Displays contact email with show/hide functionality
 */

import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { trackEvent } from '../../../../../utils/analytics/analytics';

export interface ContactEmailSectionProps {
  contactEmail: string | null | undefined;
  showContactEmail: boolean;
  onShowContactEmail: () => void;
  jobId?: string;
  companyId?: string | null;
}

const linkBtn =
  'inline-block mt-2 text-xs text-jc-accent hover:text-jc-cta-hover underline px-2 py-1 border border-jc-accent/25 rounded-lg hover:bg-jc-accent-muted/40 cursor-pointer transition-colors';

export const ContactEmailSection: React.FC<ContactEmailSectionProps> = ({
  contactEmail,
  showContactEmail,
  onShowContactEmail,
  jobId,
  companyId,
}) => {
  const intl = useIntl();

  if (!contactEmail) return null;

  if (!showContactEmail) {
    const handleShowContactEmail = () => {
      trackEvent({
        name: 'job_contact_email_reveal',
        params: {
          job_id: jobId || '',
          company_id: companyId || undefined,
          locale: intl.locale,
        },
      });
      onShowContactEmail();
    };

    return (
      <button type="button" className={linkBtn} onClick={handleShowContactEmail}>
        <FormattedMessage id="jobDetailPage.showContact" defaultMessage="Show Contact Email" description="Button label to reveal contact email address" />
      </button>
    );
  }

  return (
    <a
      href={`mailto:${contactEmail}`}
      className="inline-block mt-2 text-xs text-jc-accent hover:text-jc-cta-hover underline"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FormattedMessage id="jobDetailPage.contact" defaultMessage="Contact:" description="Label prefix for contact email address" /> {contactEmail}
    </a>
  );
};
